<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE VALOR DO KM - FOLLOWUP'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="openConfirmationModal">
      <div class="form-group row">
        <div class="col-md-3">
          <label ><small v-show="form.valor.required" class="text-danger">*</small> Valor do Km:</label>
          <div class="input-group">
            <money id="valor-despesa" :placeholder="$lang.Currency.Placeholder" class="form-control text-bold"
                      max-length="12" :value="form.valor.value"
                      v-model.lazy="form.valor.value" v-bind="$lang.Currency.Format" />
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtData"><small v-if="form.dataInicial.required" class="text-danger">*</small> Início período do valor:</label>
          <div class="input-group">
            <b-form-input type="date"
                          id="txtData"
                          name="txtData"
                          v-model="form.dataInicial.value"
                          :required="form.dataInicial.required"
                          :state="form.dataInicial.state"/>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtData"><small v-if="form.dataFinal.required" class="text-danger">*</small> Final período do valor:</label>
          <div class="input-group">
            <b-form-input type="date"
                          id="txtData"
                          name="txtData"
                          v-model="form.dataFinal.value"
                          :required="form.dataFinal.required"
                          :state="form.dataFinal.state"/>
          </div>
        </div>
      </div>
    </Forms>

    <AddConfirmation
      ref="AddConfirmationModal"
      warnText="Após o salvamento não sera possível a edição/exclusão. Deseja confirmar esta operação?"
      :saveFunction="onSave"
    />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import { advancedOnException } from '@/components/tools/Utils'

import KmValueModel from '@/shared/models/configurations/kmvaluemodel.js'
import kmValueForm from './kmValue-form.js'
import KmValueRepository from '@/shared/http/repositories/configurations/kmvalue.js'
import Tools from '@/components/tools/Tools.js'

import AddConfirmation from '@/components/UI/confirmation/addConfirmation.vue'

export default {
  name: 'kmValueAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: KmValueModel,
      form: kmValueForm
    }
  },
  components: {
    AddConfirmation
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
      this.onClear()
    },
    onEdit (obj) {
      loading.push()

      if (obj) {
        Tools.SetValueInForm(this.form, this.data, obj)
        if (obj.dataInicial) {
          this.form.dataInicial.value = this.moment(obj.dataInicial).tz('UTC').format('YYYY-MM-DD')
        }
        if (obj.dataFinal) {
          this.form.dataFinal.value = this.moment(obj.dataFinal).tz('UTC').format('YYYY-MM-DD')
        }
      }
      loading.pop()
    },
    onClear () {
      var date = new Date()
      this.data.id = null
      this.form.valor.value = 0
      this.form.dataInicial.value = `${date.getFullYear()}-${((date.getMonth() + 1) + '').padStart(2, 0)}-${(date.getDate() + '').padStart(2, 0)}`
      this.form.dataFinal.value = ''
    },
    onCreate () {
      loading.push()

      if (this.data.dataInicial) {
        this.data.dataInicial = this.data.dataInicial + 'T' + this.moment().format('HH:MM:SS.mmmmm')
      }
      if (this.data.dataFinal) {
        this.data.dataFinal = this.data.dataFinal + 'T' + this.moment().format('HH:MM:SS.mmmmm')
      }

      KmValueRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch((error) => advancedOnException(error, this.$lang))
      loading.close()
    },
    onUpdate () {
      loading.push()

      if (this.data.dataInicial) {
        this.data.dataInicial = this.data.dataInicial + 'T' + this.moment().format('HH:MM:SS.mmmmm')
      }
      if (this.data.dataFinal) {
        this.data.dataFinal = this.data.dataFinal + 'T' + this.moment().format('HH:MM:SS.mmmmm')
      }

      this.data.id = parseInt(this.data.id)
      KmValueRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch((error) => advancedOnException(error, this.$lang))
      loading.close()
    },
    openConfirmationModal () {
      this.$nextTick(() => {
        this.$refs['AddConfirmationModal'].showModal()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/kmValue/components/add/kmValueAdd.vue